import {
  sagaListSuccess,
  sagaOneSuccess,
  sagaUpdateSuccess,
  sagaCreateSuccess
} from "../actions/ActionTypes";
import { remove, find } from "lodash";

const NOTICES = "notices";
const NOTICE = "notice";
const sorter = (a, b) => a.created_at < b.created_at;
const initialState = {
  list: [],
  currentNotice: {},
  showNoticeModal: false
};
export default function notices(state = initialState, action = {}) {
  switch (action.type) {
    case "HIDE_NOTICE_MODAL":
      return { ...state, showNoticeModal: false };
    case "NEW_NOTICE":
      return { ...state, showNoticeModal: true, currentNotice: {} };
    case "EDIT_NOTICE":
      let currentNotice = find(state.list, (x) => x.id === action.data.id);
      return {
        ...state,
        showNoticeModal: true,
        currentNotice
      };
    case sagaListSuccess(NOTICES):
      return { ...state, list: action.data.data };
    case sagaOneSuccess(NOTICE):
      return { ...state, currentNotice: action.data.data };
    case sagaCreateSuccess(NOTICE):
      const current = action.data.data;
      const newList = state.list.concat([action.data.data]).sort(sorter);
      return {
        ...state,
        list: newList,
        currentNotice: current
      };
    case sagaUpdateSuccess(NOTICE):
      let updatedNotice = action.data.data;
      remove(state.list, x => x.id === updatedNotice.id);
      const newUpdatedList = state.list.concat([action.data.data]).sort(sorter);

      return {
        ...state,
        list: newUpdatedList,
        currentNotice: action.data.data
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/notices.js